import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { logToExternalErrorHandlers } from '@luminovo/commons';
import { CenteredLayout, Flexbox, NonIdealState, PrimaryButton, SecondaryButton } from '@luminovo/design-system';
import { CircleAlertIcon } from 'lucide-react';
import React from 'react';

type FallbackProps = {
    error: unknown;
    resetError?: () => void;
    onReset: () => void;
};

export const DefaultFallbackComponent: React.FunctionComponent<FallbackProps> = ({ error, resetError, onReset }) => {
    logToExternalErrorHandlers(error instanceof Error ? error : new Error(String(error)));

    const errorMessage =
        error instanceof Error ? error.message : t`An unexpected error occurred. Please try again or reload the page.`;

    const handleReset = () => {
        onReset();
        resetError?.();
    };

    return (
        <CenteredLayout>
            <NonIdealState
                variant="error"
                icon={<CircleAlertIcon />}
                title={t`Oops! Something went wrong.`}
                description={errorMessage}
                action={
                    <Flexbox gap={'8px'}>
                        <SecondaryButton size="small" onClick={() => handleReset()}>
                            <Trans>Try again</Trans>
                        </SecondaryButton>
                        <PrimaryButton
                            size="small"
                            onClick={() => {
                                handleReset();
                                window.location.reload();
                            }}
                        >
                            <Trans>Reload the page</Trans>
                        </PrimaryButton>
                    </Flexbox>
                }
            />
        </CenteredLayout>
    );
};
